/**
 * Libreria para crear un datepicker
 * 
 * https://pikaday.com
 */
let Pikaday = require('pikaday/pikaday');

const instance_pikaday = ( el ) =>
{
    new Pikaday( { 
        field: document.querySelector( el ),
        format: 'DD/MM/YYYY',
        i18n: {
            previousMonth : 'Mes Anterior',
            nextMonth     : 'Mes Siguiente',
            months        : ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
            weekdays      : ['Domindo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'],
            weekdaysShort : ['Dom','Lun','Mar','Mie','Jue','Vie','Sab']
        }
    } );
}

window.Pikaday_es = instance_pikaday;